import {
  autoPlayService,
  ErrorType,
  FeatureToggleV2Type,
  registerSpaceBarEvent,
  setErrorPopupData,
  useAutoPlayStore,
  useBetHistoryStore, useChipSetStore,
  useErrorPopupStore,
  useFeatureToggleV2Store,
  useGameRuleStore,
  useSessionLimitStore,
  usePlayerStore,
  useVoucherStore,
} from '@slot-nx/core'
import { useGodziDropStore } from '../godzi/store/godziDropStore'
import { useBetDetailStore } from '../betDetail/store/betDetailStore'
import { usePopupStore } from '../popup/popupStore'
import { threecomboolympusMachine } from '../machine/threecomboolympusMachine'
import { BetOptionType, getPayStake } from '../placeOrder/utils/stakeUtils'
import { GameStatus, useGameStore } from '../game/store/GameStore'
import { spinService } from '../game'

let lastSpinTime = 0

export const onSpin = async () => {
  // 一旦達到 session 限額（時間或虧損），即使彈窗還沒渲染出來，也不允許再開始下一手
  if (useSessionLimitStore.getState().isLimitReached) {
    autoPlayService.cancel()
    return
  }

  const now = Date.now()
  const enableBetCooldown = useFeatureToggleV2Store.getState().toggleListV2.has(FeatureToggleV2Type.enableBetCooldown)
  if (enableBetCooldown && now - lastSpinTime < 3000) return

  const currentState = threecomboolympusMachine.getSnapshot().value
  if (currentState !== 'init game' || useGameStore.getState().isReadyToStop) return
  if (!isPlayerHasEnoughBalance()) {
    setErrorPopupData(ErrorType.InsufficientBalance, { enableReload: false })
    useGameStore.setState({ betOptionType: BetOptionType.MainGame })
    autoPlayService.cancel()
    return
  }
  lastSpinTime = now
  isSkipAnim = false
  threecomboolympusMachine.send({ type: 'start spin' })
}

export const spinEvent = () => {
  const currentState = threecomboolympusMachine.getSnapshot().value
  if (currentState === 'init game') {
    onSpin()
  }
  else {
    onSpinningCallback()
  }
}

export function checkIsSkipAnim(): [ promise: Promise<void>, cancel: () => void ] {
  let cancelAnimationFrameId: number | null = null

  const task = new Promise<void>((resolve) => {
    const loop = () => {
      if (isSkipAnim) {
        // 當 isSkipAnim 為 true 時，結束並 resolve Promise
        resolve()
        return
      }
      cancelAnimationFrameId = requestAnimationFrame(loop)
    }

    // 開始檢查循環
    cancelAnimationFrameId = requestAnimationFrame(loop)
  })

  const cancel = () => {
    if (cancelAnimationFrameId !== null) {
      cancelAnimationFrame(cancelAnimationFrameId)
      cancelAnimationFrameId = null
    }
  }

  return [task, cancel]
}

export const isPlayerHasEnoughBalance = (): boolean => {
  const balance = usePlayerStore.getState().balance
  const { betOptionType, gameStatus } = useGameStore.getState()
  const stake = useChipSetStore.getState().computed.currentStake
  const payStake = getPayStake(stake, betOptionType)
  return gameStatus === GameStatus.Voucher || payStake <= balance
}

export let isSkipAnim = false
export const onSpinningCallback = () => {
  const enableSlamStop = useFeatureToggleV2Store.getState().toggleListV2.has(FeatureToggleV2Type.enableSlamStop)
  if (!enableSlamStop) return
  spinService.immediateStop()
  const isWinningState = threecomboolympusMachine.getSnapshot().matches('winning')
  if (isWinningState) isSkipAnim = true
}

const isOpenPopup = (): boolean => {
  return (
    useBetHistoryStore.getState().isOpened
    || useAutoPlayStore.getState().isEnabledPanel
    || useGameRuleStore.getState().isOpened
    || usePopupStore.getState().isOpenAny()
    || useErrorPopupStore.getState().isShow
    || useVoucherStore.getState().isShowVoucherSelectPopup
    || useVoucherStore.getState().isShowVoucherTotalWinPopup
    || useBetDetailStore.getState().isOpen
    || useGodziDropStore.getState().isShowDashboard
  )
}

export const registerNormalSpaceBarEvent = () => {
  const enableSpacebarSpin = useFeatureToggleV2Store.getState().toggleListV2.has(FeatureToggleV2Type.enableSpacebarSpin)
  if (!enableSpacebarSpin) return
  registerSpaceBarEvent(spinEvent, isOpenPopup)
}

export function waitSpaceEvent(): Promise<void> {
  return new Promise((resolve) => {
    const handler = (event: KeyboardEvent) => {
      if (event.code === 'Space') {
        event.preventDefault()
        window.removeEventListener('keydown', handler)
        resolve()
      }
    }
    window.addEventListener('keydown', handler)
  })
}
